import { render, staticRenderFns } from "./CommunityElderByAbility.vue?vue&type=template&id=7adfcf9a&scoped=true&"
import script from "./CommunityElderByAbility.vue?vue&type=script&lang=js&"
export * from "./CommunityElderByAbility.vue?vue&type=script&lang=js&"
import style0 from "./CommunityElderByAbility.vue?vue&type=style&index=0&id=7adfcf9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfcf9a",
  null
  
)

export default component.exports